<style src="./DetailsSection.scss" lang="scss" scoped></style>
<i18n src="./DetailsSection.yaml" lang="yaml"></i18n>
<script src="./DetailsSection.js"></script>

<template>
  <div class="product-dec-action-wrap pro-dec-action-2">
    <div class="quality-cart-wrap" style="min-height: unset">
      <div id="showBookingButtonHere"></div>
    </div>
  </div>

  <component :is="'script'" id="simplybookScriptTag" src="https://widget.simplybook.it/v2/widget/widget.js"></component>
  <component :is="'script'">
    function simplybookLoad(){
    var widget = new SimplybookWidget({
      widget_type: "button",
      url: "https://petsy.simplybook.it",
      theme: "hugo",
      theme_settings: {
      timeline_hide_unavailable: "1",
      hide_past_days: "0",
      timeline_show_end_time: "0",
      timeline_modern_display: "as_slots",
      nav_bg_color: "#fec107",
      sb_base_color: "#ffffff",
      display_item_mode: "block",
      body_bg_color: "#ffffff",
      sb_review_image: "",
      dark_font_color: "#6c757e",
      light_font_color: "#6c757e",
      sb_company_label_color: "#6c757e",
      hide_img_mode: "0",
      show_sidebar: "1",
      sb_busy: "#de5e18",
      sb_available: "#11d92c",
      },
      timeline: "modern",
      datepicker: "top_calendar",
      is_rtl: false,
      app_config: {
      allow_switch_to_ada: 0,
      predefined: {{ simplybook }},
      },
      button_title: "Book {{ currentVariant.name }} now",
      button_background_color: "#4a4141",
      button_text_color: "#ffffff",
      button_position: "right",
      button_position_offset: "55%",
    });
    simplybookSwitchButtonPosition();
    }
  </component>
  <component :is="'script'">
    function simplybookSwitchButtonPosition(){
    const btn = document.querySelector('.simplybook-widget-button.right');
    document.querySelector('.simplybook-widget-button.right').remove();
    document.getElementById('showBookingButtonHere').appendChild(btn);
    btn.classList.remove("right");
    btn.classList.remove("simplybook-widget-button");
    btn.style.removeProperty("background-color");
    btn.style.removeProperty("bottom");
    btn.style.padding = '15px';
    btn.style.cursor= 'pointer';
    }
  </component>
  <div
    class="description-review-wrapper"
    v-if="currentVariant"
  >
    <div class="panel-group" id="accordion1">
      <div class="panel pro-dec-accordion">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a
              href="#"
              @click.prevent="toggle(0)"
              :class="{ collapsed: !expanded[0] }"
              data-test="product-attributes-accordion"
            >
              {{ t('productDetails') }}
            </a>
          </h4>
        </div>
        <div
          data-parent="#accordion1"
          id="pro-dec-accordion1"
          class="
            product-description-wrapper
            panel-collapse
            collapse
          "
          :class="{ show: expanded[0] }"
        >
          <div class="panel-body">
            <ul class="product-features-list">
              <li
                  v-for="generalInformation in generalInformations"
                  data-test="product-attributes-list"
                  :key="generalInformation.name"
              >
                <span class="attribute-name">
                  {{ generalInformation.name }}:
                </span>
                <br>
                <span>
                  {{ generalInformation.label || generalInformation.value }}
                </span>
              </li>
            </ul>
            <hr>
            <ul class="product-features-list">
              <li
                v-for="attribute in attributes"
                data-test="product-attributes-list"
                :key="attribute.name"
              >
                <span class="attribute-name">
                  {{ attribute.name }}:
                </span>
                <span>
                  {{ attribute.label || attribute.value }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
<!--      <div class="panel pro-dec-accordion">-->
<!--        <div class="panel-heading">-->
<!--          <h4 class="panel-title">-->
<!--            <a-->
<!--              href="#"-->
<!--              @click.prevent="toggle(1)"-->
<!--              :class="{ collapsed: !expanded[1] }"-->
<!--            >-->
<!--              {{ t('developerInformation') }}-->
<!--            </a>-->
<!--          </h4>-->
<!--        </div>-->
<!--        <div-->
<!--          data-parent="#accordion1"-->
<!--          id="pro-dec-accordion2"-->
<!--          class="-->
<!--            product-description-wrapper-->
<!--            panel-collapse-->
<!--            collapse-->
<!--          "-->
<!--          :class="{ show: expanded[1] }"-->
<!--        >-->
<!--          <div class="panel-body">-->
<!--            <ul class="product-delivery-list">-->
<!--              generalInformations:-->
<!--              <pre>{{ generalInformations }}</pre>-->
<!--              <hr>-->
<!--              attributes:-->
<!--              <pre>{{ attributes }}</pre>-->
<!--              <hr>-->
<!--              currentVariant:-->
<!--              <pre>{{ currentVariant }}</pre>-->
<!--              <hr>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>
